import {spotheroGet} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';

import {EventVenue} from './events.types';

/**
 * Converts the given data object into the format expected by the frontend by renaming keys to camelCase.
 */
const formatEventVenuesResponse = (data: EventVenue[]) => {
    const formattedData = camelizeKeys(data);

    return formattedData;
};

/**
 * Gets a collection of venues for a given facility ID
 * @see '/api/v1/facilities/{facilityId}/tiered-event-rating-types/destinations/'
 */
const getEventVenues = async (facilityId: number) => {
    try {
        const response = await spotheroGet<EventVenue[]>(
            `facilities/${facilityId}/tiered-event-rating-types/destinations/`
        );

        const formattedResponse = formatEventVenuesResponse(
            response.data.data.results
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default getEventVenues;
